import { StyledContainer } from "@components/Styled/Container";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import { Video as VideoPlayer } from "@components/Video/Video";
import React from "react";
import tw from "twin.macro";
import { withVideo, type VideoOutputProps } from "./withVideo";
import Container from "@components/Atomic/Container/Container";
import { NestedWrapper } from "../NestedWrapper";

const VideoWrapper = tw.div`
  aspect-landscape relative
`;

const InnerVideoWrapper = tw.div`
  absolute inset-0
`;

const Wrapper = styledWithInvalidProps(StyledContainer)(
  ({ padding }: Partial<VideoOutputProps>) => [
    padding === "yes" ? `py-giga` : null,
  ],
);

const Parent = ({
  children,
  handleClick,
  width,
  padding,
}: Partial<VideoOutputProps>) => {
  return (
    <Wrapper width={width} padding={padding}>
      <VideoWrapper>
        <InnerVideoWrapper onClick={handleClick} data-testid="video-section">
          {children}
        </InnerVideoWrapper>
      </VideoWrapper>
    </Wrapper>
  );
};

const Child = ({ url, autoplay }: Partial<VideoOutputProps>) => {
  return <VideoPlayer video={{ url }} muted={autoplay} playing={autoplay} />;
};

const Video = withVideo(({ styles, url, ...rest }: VideoOutputProps) => {
  return (
    <Container
      styles={styles}
      legacy={!styles?.length}
      background="lightest"
      data-component-type="section-video"
    >
      {url ? (
        <NestedWrapper
          {...rest}
          url={url}
          renderChild={Child}
          renderParent={Parent}
        />
      ) : null}
    </Container>
  );
});

export default Video;
